/**
 * Function providing numebr format support according to
 * {@link https://contentsquare.atlassian.net/wiki/spaces/RD/pages/902136328/Numbers+formatting}
 * @param number
 */
export const getDisplayableDecimals = (number) => {
    const fraction = 2;
    return Math.min(fraction, fraction - Math.min(fraction, Math.floor(Math.log10(Math.abs(number) || 1))));
};
//# sourceMappingURL=get-displayable-decimals.js.map